// First sign-in with an admin-issued temporary password: the backend refuses every
// school endpoint (403 password_change_required) until /welcome replaces it.
const KEY = 'must_change_password';

export const WELCOME_PATH = '/welcome';

export function mustChangePassword(): boolean {
  try { return localStorage.getItem(KEY) === '1'; } catch { return false; }
}

export function setMustChangePassword(on: boolean) {
  try {
    if (on) localStorage.setItem(KEY, '1');
    else localStorage.removeItem(KEY);
  } catch {}
}

export function isPasswordChangeRequired(err: any): boolean {
  return err?.response?.status === 403 && err?.response?.data?.code === 'password_change_required';
}
